import { CalendarDays, LockKeyhole, UserRound } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { InfoRow } from "@/shared/components/ui/InfoRow";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";

export function AppointmentTypePage() {
  const [params] = useSearchParams();
  const { goToClientAppointmentAdd, goToCalendarEventAdd } = useAppNavigation();
  return (
    <Page>
      <PageHeader title="Add appointment" />
      <PageContent className="space-y-4">
        <div className="mx-auto max-w-2xl space-y-4">
          <InfoRow title="Client appointment" subtitle="Book a customer for one or more services." icon={<UserRound />} onClick={() => goToClientAppointmentAdd(params.get("clientId") ?? undefined, { date: params.get("date") ?? undefined, time: params.get("time") ?? undefined, startAt: params.get("startAt") ?? undefined })} className="rounded-[20px] border border-border bg-card" />
          {([{ title: "Personal event", kind: "personal", icon: CalendarDays }, { title: "Blocked time", kind: "blocked", icon: LockKeyhole }] as const).map(({ title, kind, icon: Icon }) => (
            <InfoRow
              key={title}
              title={title}
              subtitle={kind === "personal" ? "Add a personal event across all business locations." : "Block new bookings across all business locations."}
              onClick={() => goToCalendarEventAdd(kind, { date: params.get("date") ?? undefined, time: params.get("time") ?? undefined, startAt: params.get("startAt") ?? undefined })}
              icon={<Icon aria-hidden="true" />}
              className="rounded-[20px] border border-border bg-card"
            />
          ))}
        </div>
      </PageContent>
    </Page>
  );
}
